/* Avis Trustpilot — auto-fit sur une ligne.
   Réduit la police de .trustpilot UNIQUEMENT si la ligne déborde de sa colonne
   (les étoiles sont en em -> elles rétrécissent avec le texte). Sinon : taille pleine.
   Réagit à la largeur RÉELLE de la colonne (pas du viewport) -> pas de rétrécissement
   prématuré quand il y a de la place. Premier-party, ~0,4 Ko. */
(function () {
  function fit(el) {
    el.style.fontSize = '';
    var size = parseFloat(getComputedStyle(el).fontSize) || 13;
    var guard = 0;
    while (el.scrollWidth > el.clientWidth + 0.5 && size > 8 && guard < 40) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }
  function run() {
    var list = document.querySelectorAll('.trustpilot');
    for (var i = 0; i < list.length; i++) fit(list[i]);
  }
  var raf;
  function onResize() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(run);
  }
  if (document.readyState === 'loading') {
    addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  addEventListener('resize', onResize, { passive: true });
})();
